import axios from '@/plugins/axios.js'

export function list() {
    return axios.get("mp/banner/list");
}

export function remove(id){
    return axios.delete("mp/banner/"+id);
}

export function save(params) {
    return axios.post("mp/banner/save", params);
}

export function update(params) {
    return axios.post("mp/banner/update", params);
}